import styled from "styled-components";

export const ErrorsStyled = styled.div``;

export const Error = styled.div`
  font-size: 13px;
  color: red;
  text-align: right;
`;
